export const HEADER_HEIGHT = '60px';
export const SIDEBAR_MAX_WIDTH = 'auto';
export const VIDEO_SMALL_WIDTH = '300px';
export const VIDEO_SMALL_HEIGHT = '300px';
export const DEF_MARGIN = '10px';
export const CHAT_WIDTH = '400px';
export const LINK_START = '|:[';
export const LINK_END = ']:|';
export const SOCKET_ID_NAME = 'socketId';
export const TYPE_EVENT_VIEW = 1;
export const TYPE_EVENT_CLICK = 3;
export const TYPE_EVENT_VOTE = 4;
export const TYPE_EVENT_SEND_MESSAGE = 5;

export enum TYPE_ID {
  SEMINAR = 1,
  SCHOOL,
  WEBINAR,
  VIDEO_TARNING,
}

export enum TYPE_EVENT {
  ONLINE = 1,
  OFFLINE,
  RECORD,
}

export enum GROUP_SEMINAR {
  GB = 1,
  EK,
  MED,
  OP,
  GB_B,
  GB_ARGO,
  DZ,
  SC,
  BUH,
}
